module.exports = __webpack_public_path__ + "static/media/247GLA.49b7368e.jpg";